var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('HeaderTop'),_c('div',{staticClass:"layout-body"},[_c('keep-alive',{attrs:{"include":_vm.keepAliveArr}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }